import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import {
  CompanySsoConfigurationService,
  Wealthlane_Dtos_SsoProvider_CreateUpdateCompanySsoConfigurationDto,
} from '@wealthlane/api-services/wealthlane-identity-service';

const usePutCompanySso = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  props: {
    id: string;
    onSuccess: () => void;
  }
): UseMutationResult<unknown, unknown, any, unknown> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload?: Wealthlane_Dtos_SsoProvider_CreateUpdateCompanySsoConfigurationDto) => {
      const response = await handleRequest(
        CompanySsoConfigurationService.putApiIdentityApiAppCompanySsoConfiguration(
          props.id,
          payload
        )
      );
      return response;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('getCompanySsoConfigList');
        props.onSuccess();
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePutCompanySso;
